import { render, staticRenderFns } from "./modulesResources.vue?vue&type=template&id=6a06fccf&scoped=true"
import script from "./modulesResources.vue?vue&type=script&lang=js"
export * from "./modulesResources.vue?vue&type=script&lang=js"
import style0 from "./modulesResources.vue?vue&type=style&index=0&id=6a06fccf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a06fccf",
  null
  
)

export default component.exports